import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import cogoToast from "cogo-toast";
import { Consumer } from "../../context";
import Request from "../../core/httpClient";
import UnifiedDatePicker from '../../components/Calendario'; // ← Ajusta la ruta
import InputMask from 'react-input-mask';
const request = new Request();

const BlackoutDates = ({ idEspacio, context }) => {
    const [descripcion, setDescripcion] = useState('');
    const [fecha, setFecha] = useState(''); // ← sigue siendo string
    const [motivo, setMotivo] = useState('');
    const [fechasBloqueadas, setFechasBloqueadas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [loadRemoving, setLoadRemoving] = useState(false);

    useEffect(() => {
        getFechasBloqueadas();
    }, [idEspacio]);

    async function addDate(e) {
        e.preventDefault();
        setLoading(true);

        const user = await context.loadUser();

        if (user) {
            const data = {
                id_espacio: idEspacio,
                fecha_bloqueada: fecha, // ← string en formato YYYY-MM-DD
                motivo,
                usuario: user.id.nombre,
                fecha_upd: moment().format("YYYY-MM-DD HH:mm:ss"),
                tipo: 1
            };

            await saveData(data);
        } else {
            console.log("context.loadUser() devolvió null o undefined");
        }
    }

    async function removeDate(item) {
        setLoadRemoving(item.id);
        const user = await context.loadUser();

        if (user) {
            const data = {
                id_espacio: idEspacio,
                fecha_bloqueada: item.fecha,
                motivo: '',
                usuario: user.id.nombre,
                fecha_upd: moment().format("YYYY-MM-DD HH:mm:ss"),
                tipo: 2
            };
            await saveData(data);
        }
    }

    async function saveData(data) {
        try {
            const response = await request.post("/commonArea/bloquear/fecha", data);

            if (response) {
                if (response.error) {
                    cogoToast.error(response.message, { position: "bottom-right" });
                }

                if (response.updated) {
                    if (data.tipo === 1) {
                        cogoToast.success("Fecha bloqueada agregada correctamente.", { position: "bottom-right" });
                        setFecha(''); // ← limpiar string
                        setMotivo('');
                    } else {
                        cogoToast.success("Fecha bloqueada eliminada correctamente.", { position: "bottom-right" });
                    }
                    await getFechasBloqueadas();
                }

                if (response.existe) {
                    cogoToast.error(response.message, { position: "bottom-right" });
                    setFecha('');
                    setMotivo('');
                }
            }

            setLoading(false);
            setLoadRemoving(false);
        } catch (error) {
            console.log(error);
        }
    }

    async function getFechasBloqueadas() {
        try {
            setLoadingData(true);
            const response = await request.post("/commonArea/get/fechasBloqueadas", { id_espacio: idEspacio });

            if (response) {
                if (response.error) {
                    cogoToast.error(response.message, { position: "bottom-right" });
                }

                if (response.empty) {
                    setFechasBloqueadas([]);
                }

                if (response.fechas_bloqueadas) {
                    const arrayBloqueos = response.fechas_bloqueadas.map(row => ({
                        fecha: row.fecha_bloqueada,
                        motivo: row.motivo,
                        id: row.id
                    }));
                    setFechasBloqueadas(arrayBloqueos);
                }
            }

            setLoadingData(false);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="flex flex-col w-full items-center">
            <div className="w-full space-y-1.5 text-xs">

                {/* Bloque políticas de uso */}
                <div className="border rounded-md p-1.5 shadow-sm">
                    <h3 className="font-extrabold mb-1 text-lg underline text-purple-950">Políticas de uso</h3>
                    <textarea
                        name="descripcion"
                        rows="4"
                        autoComplete="off"
                        className="w-full input-edit-sm text-left"
                        value={descripcion}
                        onChange={(event) => setDescripcion(event.target.value)}
                    />
                </div>

                {/* Bloque fechas a bloquear */}
                <div className="border rounded-md p-1.5 shadow-sm space-y-1.5">
                    <h3 className="font-extrabold mb-1 text-lg underline text-purple-950">Fechas a bloquear</h3>

                    <div className="grid grid-cols-2 gap-1.5">
                        {/* Formulario para agregar fecha */}
                        <form className="flex flex-col gap-1.5" onSubmit={addDate}>
                            <div className="flex flex-col">
                                <label className="font-semibold mb-0.5 text-xs whitespace-nowrap">Fecha a bloquear:</label>

                                <UnifiedDatePicker
                                    selected={fecha ? moment(fecha, 'YYYY-MM-DD').toDate() : null}
                                    onChange={(date) => {
                                        setFecha(date ? moment(date).format('YYYY-MM-DD') : '');
                                    }}
                                    includeTime={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="DD/MM/YYYY"
                                    className="input-edit-sm text-left w-full"
                                    customInput={
                                        <InputMask
                                            mask="99/99/9999"
                                            maskChar={null}
                                            className="input-edit-sm text-left w-full"
                                            placeholder="DD/MM/YYYY"
                                        />
                                    }
                                />
                            </div>

                            <div className="flex flex-col">
                                <label className="font-semibold mb-0.5 text-xs whitespace-nowrap">Motivo:</label>
                                <input
                                    type="text"
                                    name="motivo"
                                    required
                                    className="input-edit-sm text-left"
                                    value={motivo}
                                    onChange={(e) => setMotivo(e.target.value)}
                                />
                            </div>

                            <button
                                type="submit"
                                className="bg-purple-700 hover:bg-purple-800 text-white font-semibold rounded px-2 py-1 text-xs w-full transition"
                                onClick={addDate}
                            >
                                {loading ? <i className="fas fa-spinner fa-spin"></i> : 'Agregar'}
                            </button>
                        </form>

                        {/* Tabla de fechas bloqueadas */}
                        <div className="border rounded overflow-hidden">
                            <table className="w-full text-xs">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="text-left font-semibold px-1.5 py-1">Fecha bloqueada</th>
                                        <th className="text-left font-semibold px-1.5 py-1">Motivo</th>
                                        <th className="text-center font-semibold px-1.5 py-1">Quitar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loadingData ? (
                                        <tr>
                                            <td colSpan="3" className="py-2">
                                                <div className="flex justify-center">
                                                    <i className="fas fa-spinner fa-spin"></i>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : fechasBloqueadas.length !== 0 ? (
                                        fechasBloqueadas.map((item, i) => (
                                            <tr key={i} className="border-t">
                                                <td className="px-1.5 py-1 text-left">{moment(item.fecha).format("DD/MM/YYYY")}</td>
                                                <td className="px-1.5 py-1 text-left">{item.motivo}</td>
                                                <td className="px-1.5 py-1 text-center">
                                                    {loadRemoving === item.id ? (
                                                        <i className="fas fa-spinner fa-spin"></i>
                                                    ) : (
                                                        <i
                                                            className="fas fa-times-circle text-red-600 cursor-pointer"
                                                            onClick={() => removeDate(item)}
                                                        ></i>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="py-2 text-center">
                                                <h4 className="font-semibold">No se encontraron resultados.</h4>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Consumer(BlackoutDates);